import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { AppTokenHandler } from '../../common/app-token-handler';
import { DataService } from '../../common/data.service';
import { AlertService } from '../../common/alert.service';
import { IAuditTrail, IBPAddress, IBPRecord, IGSTINType, Roles } from '../../model/bp-record';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ProgressService } from '../../common/progress.service';
import { getLocaleDateTimeFormat } from '@angular/common';

@Component({
  selector: 'app-bprecords-details',
  templateUrl: './bprecords-details.component.html',
  styleUrls: ['./bprecords-details.component.css']
})
export class BprecordsDetailsComponent implements OnInit {
  moment: any = moment;
  loading: boolean = false;
  showUnregistered: boolean = false;

  showGSTTypeError: boolean = false;
  showGSTNReasonError: boolean = false;
  showPanReasonError: boolean = false;
  showGSTNAttachError: boolean = false;
  showDecAttachError: boolean = false;
  showLoaAttachError: boolean = false;
  showPanAttachError: boolean = false;
  showTanReasonError: boolean = false;
  showGstTanError: boolean = false;
  showGstnNoError: boolean = false;
  showLoaValidationError: boolean = false;
  showLoaDateToError: boolean = false;
  showLoaDateFromError: boolean = false;
  showLoa: boolean = false;

  showTax1IdError: boolean = false;
  showTax1CountryError: boolean = false;
  showTax4IdError: boolean = false;
  showTax4CountryError: boolean = false;
  showTax3CountryError: boolean = false;
  showVatError: boolean = false;
  showVatCountryError: boolean = false;
  showNationalIdError: boolean = false;
  showNationalIdCountryError: boolean = false;

  IsThisGovernmentClient: boolean = false;
  IsGstinAstaxDeductor: boolean = false;

  cols: any[];
  roles = Roles;
  gstFile: any;
  panFile: any;
  loaFile: any;
  declarationFile: any;
  confirmtype: string = "";
  ECCIDRecordList: Array<IBPAddress> = [];

  bprecord: IBPRecord;
  paramid: any;
  auditCols: any[];
  displayAuditTrail: boolean = false;
  auditloading: boolean = false;
  first: number = 0;
  auditTrailList: Array<IAuditTrail> = [];
  selectedAuditTrailList: Array<IAuditTrail> = [];
  showComment: boolean = false;

  paramAll: string | null;
  paramIsMy: any = '';
  paramIsClient: string | null;
  paramIsDpc: string | null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private route: Router,
    private bpRecordService: DataService,
    private messageService: MessageService,
    private router: Router,
    private appToken: AppTokenHandler,
    private progressService: ProgressService,
    private fb: FormBuilder
  ) { }

  bpRecordForm: FormGroup = this.fb.group({
    MdmId: [''],
    BPName: [''],
    BPClassification: [''],
    AddressLine1: [''],
    AddressLine2: [''],
    AddressLine3: [''],
    AddressLine4: [''],
    AddressLine5: [''],
    City: [''],
    PostalCode: [''],
    BPCountry: [''],
    BPEmail: [''],
    BPPhoneNo: [''],
    BPRegionName: [''],
    BPAreaName: [''],
    EntityType: [''],
    BPStageName: [''],
    Pace_ID: [''],
    PACEStatus: [''],
    ProspectSubmitter: [''],
    StateProvinceRef: [''],
    StateProvinceName: [''],
    VatId: [''],
    VatIdCountry: [''],
    Tax1Id: [''],
    Tax1Country: [''],
    Tax2Id: [''],
    Tax2Country: [''],
    PANAttachmentName: [''],
    Tax3Id: [''],
    Tax3Country: [''],
    GSTAttachmentName: [''],
    DeclarationAttachmentName: [''],
    LoaAttachmentName: [''],
    LoaValidityFrom: [''],
    LoaValidityTo: [''],
    GSTINTypeName: [''],
    GSTINType: [''],
    Tax4Id: [''],
    Tax4Country: [''],
    Tax5Id: [''],
    Tax5Country: [''],
    NationalId: [''],
    NationalIdCountry: [''],
    IsGovernmentClient: [''],
    ReasonNonAvailabilityGSTIN: [''],
    ReasonNonAvailabilityPAN: [''],
    ReasonNonAvailabilityTAN: [''],
    GstTan: [''],
    Comment: ['']
  });

  gstnypeList: Array<IGSTINType> = [
    {
      Id: 0,
      Name: '-- select --',
    },
    {
      Id: 1,
      Name: 'DT – Regular',
    },
    {
      Id: 2,
      Name: 'UI – United Nation Body',
    },
    {
      Id: 3,
      Name: 'IS – Input Service Distributor',
    },
    {
      Id: 4,
      Name: 'S1 – SEZ Unit / Developer',
    },
    // {
    //   Id: 5,
    //   Name: 'S1 – SEZ Developer',
    // },
    {
      Id: 6,
      Name: 'UN – unregistered',
    },

  ];

  onClickEccId(id) {
    let encriptedId = this.bpRecordService.EncryptData(id);
    if (this.paramAll) {
      this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isall: true } });
    } else if (this.paramIsClient) {
      this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isclient: true } });
    } else if (this.paramIsDpc) {
      this.router.navigate(['/home/ecciddetails'], { queryParams: { id: encriptedId, isdpc: true } });
    }

    //this.router.navigate(['/home/ecciddetails'], { queryParams: { id: id } });
  }

  filterForm: FormGroup = this.fb.group({
    EccId: ['']
  });

  ngOnInit() {
    this.paramIsMy = this.activatedRoute.snapshot.queryParamMap.get('ismy');
    this.paramAll = this.activatedRoute.snapshot.queryParamMap.get('isall');
    this.paramIsClient = this.activatedRoute.snapshot.queryParamMap.get('isclient');
    this.paramIsDpc = this.activatedRoute.snapshot.queryParamMap.get('isdpc');

    this.cols = [
      { field: 'EccId', header: 'ECC ID' },
      { field: 'RequestorName', header: 'Requestor Name' },
      { field: 'EccStatus', header: 'EccStatus' },
      { field: 'UpdatedOn', header: 'Updated On' },
    ];

    this.auditCols = [
      { field: 'Name', header: 'Name', hidden: false },
      { field: 'CreatedOn', header: 'Updated On', hidden: false, width: '100px' },
      { field: 'FieldName', header: 'Field Name', hidden: false, width: '150px' },
      { field: 'OldValue', header: 'Old Value', hidden: false, width: '150px' },
      { field: 'NewValue', header: 'New Value', hidden: false, width: '100px' },
      { field: 'Action', header: 'Action', hidden: false, width: '200px' },
    ];

    this.paramid = this.activatedRoute.snapshot.queryParamMap.get('id');
    this.paramid = this.bpRecordService.DecryptData(this.paramid);

    this.bpRecordService.GetData('GetBPRecords/' + this.paramid + '/' + this.paramIsClient).subscribe(
      (data: any) => {
        this.bprecord = data;
        this.progressService.ChangeProgressStatus(false);
        this._initForm();
      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'error', _error.statusText);
      }
    );

    this.loadData(false);
  }

  loadData(isFilter: boolean) {
    this.loading = true;

    this.bpRecordService.GetDataById('GetBPAddress', this.paramid).subscribe(
      (data: any) => {
        this.ECCIDRecordList = data;
        this.loading = false;
      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.loading = false;
        this.alertService.notify('error', 'error', _error.statusText);
      }
    );
  }

  private _initForm(): void {
    this.bpRecordForm.patchValue({
      MdmId: this.bprecord.MdmId,
      BPName: this.bprecord.BPName,
      BPClassification: this.bprecord.BPClassification,
      AddressLine1: this.bprecord.AddressLine1,
      AddressLine2: this.bprecord.AddressLine2,
      AddressLine3: this.bprecord.AddressLine3,
      AddressLine4: this.bprecord.AddressLine4,
      AddressLine5: this.bprecord.AddressLine5,
      City: this.bprecord.City,
      PostalCode: this.bprecord.PostalCode,
      BPCountry: this.bprecord.BPCountry,
      BPEmail: this.bprecord.BPEmail,
      BPPhoneNo: this.bprecord.BPPhoneNo,
      BPRegionName: this.bprecord.BPRegionName,
      BPAreaName: this.bprecord.BPAreaName,
      EntityType: this.bprecord.EntityType,
      BPStageName: this.bprecord.BPStageName,
      Pace_ID: this.bprecord.Pace_ID,
      PACEStatus: this.bprecord.PACEStatus,
      ProspectSubmitter: this.bprecord.ProspectSubmitter,
      StateProvinceRef: this.bprecord.StateProvinceRef,
      StateProvinceName: this.bprecord.StateProvinceName,
      VatId: this.bprecord.VatId,
      VatIdCountry: this.bprecord.VatIdCountry,
      Tax1Id: this.bprecord.Tax1Id,
      Tax1Country: this.bprecord.Tax1Country,
      Tax2Id: this.bprecord.Tax2Id,
      Tax2Country: this.bprecord.Tax2Country,
      PANAttachmentName: this.bprecord.PANAttachmentName,
      Tax3Id: this.bprecord.Tax3Id,
      Tax3Country: this.bprecord.Tax3Country,
      GSTAttachmentName: this.bprecord.GSTAttachmentName,
      DeclarationAttachmentName: this.bprecord.DeclarationAttachmentName,
      LoaAttachmentName: this.bprecord.LoaAttachmentName,
      LoaValidityFrom: this.bprecord.LoaValidityFrom ? new Date(this.bprecord.LoaValidityFrom) : null,
      LoaValidityTo: this.bprecord.LoaValidityTo ? new Date(this.bprecord.LoaValidityTo) : null,
      GSTINTypeName: this.bprecord.GSTINTypeName,
      GSTINType: this.gstnypeList.find(gs => gs.Id === this.bprecord.GSTINTypeId),
      Tax4Id: this.bprecord.Tax4Id,
      Tax4Country: this.bprecord.Tax4Country,
      Tax5Id: this.bprecord.Tax5Id,
      Tax5Country: this.bprecord.Tax5Country,
      NationalId: this.bprecord.NationalId,
      NationalIdCountry: this.bprecord.NationalIdCountry,
      Comment: this.bprecord.Comment,

      GstTan: this.bprecord.GstTan,
      ReasonNonAvailabilityGSTIN: this.bprecord.ReasonNonAvailabilityGSTIN,
      ReasonNonAvailabilityPAN: this.bprecord.ReasonNonAvailabilityPAN,
      ReasonNonAvailabilityTAN: this.bprecord.ReasonNonAvailabilityTAN,
    });

    this.IsThisGovernmentClient = this.bprecord.IsGovernmentClient;
    this.IsGstinAstaxDeductor = this.bprecord.IsGstinAstaxDeductor;

    if (this.bprecord.GSTINTypeId === 6) {
      this.showUnregistered = true;
    } else if (this.bprecord.GSTINTypeId === 4 || this.bprecord.GSTINTypeId === 5) {
      this.showLoa = true;
    }
  }

  onShowAuditTrail() {
    this.displayAuditTrail = false;
    this.bpRecordService.GetData('GetAllAuditTrailByID/' + this.paramid + '/bprecordBO').subscribe(
      (data: any) => {
        this.auditTrailList = data;
        this.displayAuditTrail = true;
        this.progressService.ChangeProgressStatus(false);
      });
  };

  submitRecord() {
    let bpRecordData: IBPRecord = this.bpRecordForm.value;

    // validation
    this.showGSTNReasonError = false;
    this.showGstTanError = false;
    this.showPanReasonError = false;
    this.showTanReasonError = false;
    this.showLoaValidationError = false;
    this.showLoaAttachError = false;
    this.showLoaDateToError = false;
    this.showLoaDateFromError = false;
    this.showPanAttachError = false;
    this.showDecAttachError = false;
    this.showGSTNAttachError = false;
    this.showGSTTypeError = false;
    this.showGstnNoError = false;

    this.showTax1IdError = false;
    this.showTax1CountryError = false;
    this.showTax4IdError = false;
    this.showTax4CountryError = false;
    this.showTax3CountryError = false;
    this.showVatError = false;
    this.showVatCountryError = false;
    this.showNationalIdError = false;
    this.showNationalIdCountryError = false;

    // set gst type 
    if (this.bpRecordForm.value.GSTINType && this.bpRecordForm.value.GSTINType.Id > 0) {
      bpRecordData.GSTINTypeId = this.bpRecordForm.value.GSTINType.Id;
      bpRecordData.GSTINTypeName = this.bpRecordForm.value.GSTINType.Name;
    } else {
      this.showGSTTypeError = true;
    }

    if ((bpRecordData.GSTINTypeId === 4 || bpRecordData.GSTINTypeId === 5) && (!bpRecordData.LoaValidityFrom || !bpRecordData.LoaValidityTo)) {
      this.showLoaValidationError = true;
    }

    if ((bpRecordData.GSTINTypeId === 4 || bpRecordData.GSTINTypeId === 5)) {
      if (bpRecordData.LoaValidityTo && new Date(bpRecordData.LoaValidityTo) < new Date()) {
        this.showLoaDateToError = true;
      }
      if (bpRecordData.LoaValidityFrom && bpRecordData.LoaValidityTo && new Date(bpRecordData.LoaValidityFrom) > new Date(bpRecordData.LoaValidityTo)) {
        this.showLoaDateFromError = true;
      }
    }

    bpRecordData.IsGovernmentClient = this.IsThisGovernmentClient;
    bpRecordData.IsGstinAstaxDeductor = this.IsGstinAstaxDeductor;

    if (this.IsThisGovernmentClient && this.IsGstinAstaxDeductor && !bpRecordData.GstTan) {
      this.showGstTanError = true;
    }

    if (!bpRecordData.Tax2Id && !bpRecordData.ReasonNonAvailabilityPAN) {
      this.showPanReasonError = true;
    }

    if (!bpRecordData.Tax4Id && !bpRecordData.ReasonNonAvailabilityTAN) {
      this.showTanReasonError = true;
    }

    this.gstFile = document.getElementById("fileGst");
    const formDataGstFile = new FormData();
    if (this.gstFile.files.length > 0) {
      formDataGstFile.append(this.gstFile.files[0].name, this.gstFile.files[0]);
    }

    this.panFile = document.getElementById("filePan");
    const formDataPanFile = new FormData();
    if (this.panFile.files.length > 0) {
      formDataPanFile.append(this.panFile.files[0].name, this.panFile.files[0]);
    }

    this.declarationFile = document.getElementById("fileDeclaration");
    const formDataDeclarationFile = new FormData();
    if (this.declarationFile && this.declarationFile.files.length > 0) {
      formDataDeclarationFile.append(this.declarationFile.files[0].name, this.declarationFile.files[0]);
    }

    this.loaFile = document.getElementById("fileLoa");
    const formDataLoaFile = new FormData();
    if (this.loaFile && this.loaFile.files.length > 0) {
      formDataLoaFile.append(this.loaFile.files[0].name, this.loaFile.files[0]);
    }

    // if (this.panFile.files.length == 0 && !this.bprecord.PANAttachmentName) {
    //   this.showPanAttachError = true;
    // }

    if ((bpRecordData.GSTINTypeId === 4 || bpRecordData.GSTINTypeId === 5) && (this.loaFile.files.length == 0 && !this.bprecord.LoaAttachmentName)) {
      this.showLoaAttachError = true;
    }


    if (bpRecordData.GSTINTypeId === 6 && this.declarationFile.files.length == 0 && !this.bprecord.DeclarationAttachmentName && bpRecordData.BPCountry && bpRecordData.BPCountry.toString().toUpperCase() == 'INDIA') {
      this.showDecAttachError = true;
    }
    if (bpRecordData.GSTINTypeId === 6 && bpRecordData.BPCountry && bpRecordData.BPCountry.toString().toUpperCase() == 'INDIA' && !bpRecordData.ReasonNonAvailabilityGSTIN) {
      this.showGSTNReasonError = true;
    }

    if (bpRecordData.BPCountry && bpRecordData.BPCountry.toString().toUpperCase() == 'INDIA' && bpRecordData.BPClassification != 'Individual'
      && (!bpRecordData.Tax4Id || bpRecordData.Tax4Id == '') && (bpRecordData.ReasonNonAvailabilityTAN == null || bpRecordData.ReasonNonAvailabilityTAN == '')) {
      this.showTax4IdError = true;
    }

    if (bpRecordData.BPCountry && bpRecordData.BPCountry.toString().toUpperCase() == 'INDIA' && bpRecordData.BPClassification != 'Individual'
      && (!bpRecordData.Tax4Country || bpRecordData.Tax4Country == '') && (bpRecordData.ReasonNonAvailabilityTAN == null || bpRecordData.ReasonNonAvailabilityTAN == '')) {
      this.showTax4CountryError = true;
    }

    // if (!bpRecordData.VatId || bpRecordData.VatId == '') {
    //   this.showVatError = true;
    // }

    // if (!bpRecordData.VatIdCountry || bpRecordData.VatIdCountry == '') {
    //   this.showVatCountryError = true;
    // }

    // if (!bpRecordData.NationalId || bpRecordData.NationalId == '') {
    //   this.showNationalIdError = true;
    // }

    if (!bpRecordData.NationalIdCountry || bpRecordData.NationalIdCountry == '') {
      this.showNationalIdCountryError = true;
    }
    // 22AAAAA0000A1Z5
    let GSTINNoPattern = '^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[a-zA-Z0-9]{3}';
    if (bpRecordData.GSTINTypeId != 6 && (!bpRecordData.Tax3Id || bpRecordData.Tax3Id == '')) {
      this.showGstnNoError = true;
    }

    if (bpRecordData.GSTINTypeId != 6 && (!bpRecordData.Tax3Country || bpRecordData.Tax3Country == '')) {
      this.showTax3CountryError = true;
    }

    if (bpRecordData.GSTINTypeId != 6 && this.gstFile.files.length == 0 && !this.bprecord.GSTAttachmentName) {
      this.showGSTNAttachError = true;
    }

    if (bpRecordData.Tax3Id && !bpRecordData.Tax3Id.match(GSTINNoPattern)) {
      this.showGstnNoError = true;
    }

    if (this.showGSTNReasonError || this.showGstTanError || this.showPanReasonError ||
      // this.showTax1IdError || this.showTax1CountryError || this.showVatError || this.showVatCountryError || this.showNationalIdError || this.showNationalIdCountryError || this.showPanAttachError ||
      this.showTanReasonError || this.showGSTNAttachError || this.showGSTTypeError || this.showGstnNoError || this.showTax4IdError || this.showTax4CountryError || this.showTax3CountryError || this.showDecAttachError || this.showLoaAttachError || this.showLoaValidationError || this.showLoaDateToError || this.showLoaDateFromError) {

      this.alertService.notify('warn', 'Warning', 'Please fixed the validation errors in the form below and try again!');
      return;
    }
    let sources: any = [];

    if (this.gstFile && this.gstFile.files && this.gstFile.files.length > 0) {
      sources.push(this.bpRecordService.DownloadFileWithPost('UploadGstFileBlob/' + this.paramid, formDataGstFile))
    }
    if (this.panFile && this.panFile.files && this.panFile.files.length > 0) {
      sources.push(this.bpRecordService.DownloadFileWithPost('UploadPanFileBlob/' + this.paramid, formDataPanFile))
    }
    if (this.loaFile && this.loaFile.files && this.loaFile.files.length > 0) {
      sources.push(this.bpRecordService.DownloadFileWithPost('UploadLoaFileBlob/' + this.paramid, formDataLoaFile))
    }
    if (this.declarationFile && this.declarationFile.files && this.declarationFile.files.length > 0) {
      sources.push(this.bpRecordService.DownloadFileWithPost('UploadDeclarationFileBlob/' + this.paramid, formDataDeclarationFile))
    }

    sources.push(this.bpRecordService.PostData('UpdateBPRecord/' + this.paramid, bpRecordData))

    forkJoin(sources).subscribe(
      (
        data
      ) => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('success', 'Success', 'Record updated successfully');
        if (this.paramAll) {
          if (this.paramIsClient) {
            this.router.navigate(['/home/clientbprecordsalluser'], { queryParams: { isall: true, isclient: true } });
          } else if (this.paramIsDpc) {
            this.router.navigate(['/home/dpcbprecordsall'], { queryParams: { isall: true, isdpc: true } });
          } else {
            this.router.navigate(['/home/financebprecordsall'], { queryParams: { isall: true } });
          }
        }
        else if (this.paramIsClient) {
          this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
        } else if (this.paramIsDpc) {
          this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
        }

      },
      error => {
        this.alertService.notify('error', 'Error', error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }
    )

    /*forkJoin([
      this.bpRecordService.DownloadFileWithPost('UploadGstFile/' + this.paramid, formDataGstFile),
      this.bpRecordService.DownloadFileWithPost('UploadPanFile/' + this.paramid, formDataPanFile),
      this.bpRecordService.DownloadFileWithPost('UploadLoaFile/' + this.paramid, formDataLoaFile),
      this.bpRecordService.DownloadFileWithPost('UploadDeclarationFile/' + this.paramid, formDataDeclarationFile),
      this.bpRecordService.PostData('UpdateBPRecord/' + this.paramid, bpRecordData),
    ]).subscribe(
      ([
        data1,
        data2,
        data3,
        data4,
        data5,
      ]) => {
        if (data5 == 1) {
          this.progressService.ChangeProgressStatus(false);
          this.alertService.notify('success', 'Success', 'Record updated successfully');
          if (this.paramIsClient) {
            this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
          } else if (this.paramIsDpc) {
            this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
          }
        }
      },
      error => {
        alert(error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }
    )*/
  }

  approveRecord() {
    this.showComment = false;

    let bpRecordData: IBPRecord = this.bpRecordForm.value;

    this.bpRecordService.PostData('ApproveBPRecord/' + this.paramid, bpRecordData).subscribe((data) => {
      if (data == 1) {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('success', 'Success', 'Record Approved successfully');
        if (this.paramIsClient) {
          this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
        } else if (this.paramIsDpc) {
          this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
        }
      }
    },
      error => {
        alert(error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }
    )
  }

  showConfirm(_confirmtype: string) {
    this.confirmtype = _confirmtype;
    let confirmMessage: string = "";

    if (this.confirmtype == "return") {

      confirmMessage = "Are you sure you want to return?";
    }

    this.messageService.clear();
    this.messageService.add({ key: 'c', sticky: true, severity: 'warn', summary: confirmMessage, detail: '' });

  }

  onExit(_confirmtype: string) {
    if (this.paramAll) {
      if (this.paramIsClient) {
        this.router.navigate(['/home/clientbprecordsalluser'], { queryParams: { isall: true, isclient: true } });
      } else if (this.paramIsDpc) {
        this.router.navigate(['/home/dpcbprecordsall'], { queryParams: { isall: true, isdpc: true } });
      } else {
        this.router.navigate(['/home/financebprecordsall'], { queryParams: { isall: true } });
      }
    }
    else if (this.paramIsClient) {
      this.router.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
    } else if (this.paramIsDpc) {
      this.router.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
    }
  }

  onConfirm(confirmtype: string) {
    this.messageService.clear('c');
    if (this.confirmtype == "return") {
      this.returnRecord();
    }
  }

  onReject() {
    this.messageService.clear('c');
  }

  returnRecord() {
    if (this.bpRecordForm.value.Comment == null || this.bpRecordForm.value.Comment == '') {
      this.showComment = true;
      this.alertService.notify('warn', 'Warn', 'Please fixed the validation errors in the form below  and try again!');
      return;
    }

    this.bpRecordForm.controls['Comment'].markAsDirty();

    let bpRecordData: IBPRecord = this.bpRecordForm.value;

    this.bpRecordService.PostData('ReturnBPRecord/' + this.paramid, bpRecordData).subscribe((data) => {
      if (data == 1) {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('success', 'Success', 'Record Return successfully');
        if (this.paramIsClient) {
          this.route.navigate(['/home/clientserverbprecords'], { queryParams: { isclient: true } });
        } else if (this.paramIsDpc) {
          this.route.navigate(['/home/dpcbprecords'], { queryParams: { isdpc: true } });
        }
      }
    },
      error => {
        alert(error.statusText);
        this.progressService.ChangeProgressStatus(false);
      }
    )
  }

  downloadGstFile() {
    this.bpRecordService.GetFileDataById('DownloadGstFileBlob', this.paramid).subscribe(
      (data: any) => {
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  downloadPanFile() {
    this.bpRecordService.GetFileDataById('DownloadPanFileBlob', this.paramid).subscribe(
      (data: any) => {
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  downloadDeclarationFile() {
    this.bpRecordService.GetFileDataById('DownloadBPRecordDeclarationFileBlob', this.paramid).subscribe(
      (data: any) => {
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  downloadLoaFile() {
    this.bpRecordService.GetFileDataById('DownloadBPRecordLoaAttachmentFileBlob', this.paramid).subscribe(
      (data: any) => {
        let file = new Blob([data], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        let h = 500;
        let w = 700;
        var y = window.outerHeight / 2 + window.screenY - (h / 2)
        var x = window.outerWidth / 2 + window.screenX - (w / 2)
        this.progressService.ChangeProgressStatus(false);
        window.open(fileURL, '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + y + ', left=' + x);

      }, _error => {
        this.progressService.ChangeProgressStatus(false);
        this.alertService.notify('error', 'Error', 'No such file found!');
      }
    );
  }

  paginate(event) {
    this.first = event.first;
  }

  get f() {
    return this.filterForm.controls;
  }

  get bpf() {
    return this.bpRecordForm.controls;
  }

  userHasRole(roleId: number) {
    let visible: boolean = false;
    if (this.appToken.IsInRole(Roles[roleId])) {
      visible = true;
    }
    return visible;
  }

  resetAll() {
    this.filterForm.reset();
    this.loadData(false);
  }

  fileInputChange(event) {
    for (var i = 0; i < event.target.files.length; i++) {
      var f = event.target.files[i];
      if (!f.name.toString().endsWith('.pdf')) {
        this.alertService.notify('warn', 'Warn', 'Unsupported File,Only Pdf allowed. Please try again!');
        //event.target.parentElement.firstElementChild.innerText = ''
        event.target.value = null
        return;
      } else {
        event.target.parentElement.firstElementChild.innerText = f.name.toString();
      }
    }
  }

  onGstnTypeChange(event) {
    event.value.Id == 6 ? this.showUnregistered = true : this.showUnregistered = false;
    event.value.Id == 4 || event.value.Id == 5 ? this.showLoa = true : this.showLoa = false;
  }

  getStatus() {
    let status: string = '';
    switch (this.bprecord && this.bprecord.MdmStatus) {
      case 1: status = 'Pending with Client server'
        break;
      case 2: status = 'Pending with DPC for review'
        break;
      case 3: status = 'Reviewed'
        break;
    }

    return status;
  }

  isDpc() {
    let isDisabled = true;
    if (this.userHasRole(this.roles.DPC) && this.bprecord && this.bprecord.MdmStatus === 2 && this.paramIsDpc) {
      isDisabled = false;
    }
    return isDisabled;
  }

  displaySubmit() {
    let isDisplay = false;
    if (this.bprecord.MdmStatus == 3 && (!this.bprecord.Tax3Id || !this.bprecord.Tax3Country || !this.bprecord.GSTAttachmentName || !this.bprecord.DeclarationAttachmentName || !this.bprecord.LoaAttachmentName || !this.bprecord.Tax4Id || !this.bprecord.Tax4Country)) {
      isDisplay = true;
    }
    else if (this.bprecord.MdmStatus == 1) {
      isDisplay = true;
    }
    return isDisplay
  }

  isDisabled(value) {
    let isDisabled = false;
    if (this.bprecord && this.bprecord.MdmStatus == 2) {
      isDisabled = true;
    } else if (this.bprecord && this.bprecord.MdmStatus == 1) {
      isDisabled = false;
    } else if (value && this.bprecord.MdmStatus == 3) {
      isDisabled = true;
    }
    return isDisabled;
  }

  /* TEMP
  isPropectSubmitter() {
    let isDisabled = true;
    if (this.userHasRole(this.roles.ProspectSubmitter) && this.bprecord && this.bprecord.MdmStatus === 1 && this.paramIsClient && this.bprecord.ProspectSubmitterGPN == this.appToken.getLoginUserInfo().EmpGPN) {
      isDisabled = false;
    }
    return isDisabled;
  }
  */

}

